import splitJpg from "./split.jpg";
import splitWebp from "./split.webp";

export const split = { jpg: splitJpg, webp: splitWebp };
